import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const isDev = import.meta.env.DEV

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are not set. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env.local file.')
  
  if (isDev) {
    console.info('Running in development mode - using placeholder Supabase config')
  }
}

const fallbackUrl = isDev ? 'https://placeholder.supabase.co' : null
const fallbackKey = isDev ? 'placeholder-key' : null

const REMEMBER_ME_KEY = 'easyappicon-remember-me'

function getRememberMe() {
  try {
    return localStorage.getItem(REMEMBER_ME_KEY) !== 'false'
  } catch {
    return true
  }
}

export function setRememberMe(value) {
  try {
    localStorage.setItem(REMEMBER_ME_KEY, String(value))
  } catch { /* ignore */ }
}

// Storage adapter that delegates to localStorage or sessionStorage based on rememberMe preference
const adaptiveStorage = {
  getItem(key) {
    const storage = getRememberMe() ? localStorage : sessionStorage
    return storage.getItem(key)
  },
  setItem(key, value) {
    const storage = getRememberMe() ? localStorage : sessionStorage
    storage.setItem(key, value)
  },
  removeItem(key) {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  },
}

export const supabase = createClient(
  supabaseUrl || fallbackUrl, 
  supabaseAnonKey || fallbackKey,
  {
    auth: {
      storage: adaptiveStorage,
      persistSession: true,
      autoRefreshToken: true,
    }
  }
)

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey)
